import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import ServiceMaize from "../views/services/Adventure";
import ServiceSorghum from "../views/services/Safaris";
import ServiceSunflower from "../views/services/Trekking";
import ServiceSesame from "../views/services/Zanzibar";
import ServiceDistribution from "../views/services/Luxury";
import Nungwi from "../views/services/Nungwi";
import Kilimanjaro from "../views/services/Kilimanjaro";
import Wildlife from "../views/services/Wildlife";
import Islands from "../views/services/Islands";
import Machame from "../views/services/Machame";
import Stone from "../views/services/Stone";
import Beaches from "../views/services/Beaches";
import Lemosho from "../views/services/Lemosho";
import Rongai from "../views/services/Rongai";
import Serengeti from "../views/services/Serengeti";
import Migration from "../views/services/Migration";
import Marangu from "../views/services/Marangu";
import TZ from "../views/services/TZ";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
    if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
      return <ServicesLanding />;
    }

    if (appContext.navSubItem === "adventure") {
      return <ServiceMaize />;
    }

    if (appContext.navSubItem === "safaris") {
      return <ServiceSorghum />;
    }

    if (appContext.navSubItem === "trekking") {
      return <ServiceSunflower />;
    }

    if (appContext.navSubItem === "zanzibar") {
      return <ServiceSesame />;
    }

    if (appContext.navSubItem === "luxury") {
      return <ServiceDistribution />;
    } 
    
     if (appContext.navSubItem === "nungwi") {
      return <Nungwi />;
    }

    if (appContext.navSubItem === "kilimanjaro") {
      return <Kilimanjaro />;
    }


    if (appContext.navSubItem === "photographic") {
      return <Wildlife />;
    }

      if (appContext.navSubItem === "islands") {
      return <Islands />;
    }

     if (appContext.navSubItem === "machame") {
      return <Machame />;
    }

    
     if (appContext.navSubItem === "marangu") {
      return <Marangu />;
    }

     if (appContext.navSubItem === "stone-town") {
      return <Stone />;
    }

    if (appContext.navSubItem === "beach") {
      return <Beaches />;
    }

     if (appContext.navSubItem === "lemosho") {
      return <Lemosho />;
    }

     if (appContext.navSubItem === "rongai") {
      return <Rongai />;
    }

    if (appContext.navSubItem === "stone-town") {
      return <Stone />;
    }

    if (appContext.navSubItem === "rivers") {
      return <Serengeti />;
    }

     if (appContext.navSubItem === "migration") {
      return <Migration />;
    }

    
     if (appContext.navSubItem === "serengeti") {
      return <Serengeti />;
    }

     if (appContext.navSubItem === "tanzania_zanzibar") {
      return <TZ />;
    }

    

    return <ServicesLanding />;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
